/**
 * Sec-GPC (Global Privacy Control) header propagation per ADR 099 §1.
 *
 * When the user agent asserts `navigator.globalPrivacyControl === true`, every
 * outbound request — including `FormData` uploads — must carry `Sec-GPC: 1`
 * so the backend `GPCMiddleware` can record the opt-out.
 *
 * Returns a `BeforeRequestHook` rather than mutating a global so the lib
 * remains test-isolatable. The hook is composed into the ky instance built
 * by `transport.ts`.
 *
 * Spec: https://globalprivacycontrol.github.io/gpc-spec/
 */
import type { BeforeRequestHook } from 'ky';

export function gpcBeforeRequest(): BeforeRequestHook {
  return ({ request }) => {
    try {
      if (
        typeof navigator !== 'undefined' &&
        (navigator as Navigator & { globalPrivacyControl?: boolean })
          .globalPrivacyControl === true
      ) {
        request.headers.set('Sec-GPC', '1');
      }
    } catch {
      // navigator unavailable (SSR / atypical test env) — silently skip.
    }
  };
}
